/* eslint-disable no-unused-vars */
import React from 'react';
import AccountStepper from '../../Common/Profile/AccountStepper';

export default function AccountSetupSteps({
	userId = '',
	error = '',
	redirectToKyc = () => {},
	kycStatus = {},
	loading = false
}) {
	return (
		<AccountStepper
			error={error}
			submission_date={kycStatus?.submission_date ? true : false}
			hasWallet={kycStatus?.wallet_connected}
			exclaimation={
				kycStatus?.kyc_status === 'Rejected' &&
				kycStatus?.submission_date &&
				kycStatus?.reason_of_kyc_rejection !== 'Must specify a valid sub wallet'
			}
			loading={loading}
			redirectToKyc={redirectToKyc}
			userid={userId}
			approved={kycStatus?.kyc_status === 'Approved'}
			pending={kycStatus?.kyc_status === 'Pending'}
		/>
	);
}
